type PhoneTypeCategory = {
  id: number;
  descricao: string;
};
type CustomerCategory = 'I' | 'J' | 'C' | 'O' | 'F' | 'S';

type TelefonesClientePropostaResponse = {
  ddd: string;
  telefone: string;
  sequencia: number;
  tipo: PhoneTypeCategory;
  categoria: PhoneTypeCategory;
  ramal: string;
  contato: string;
};

export class CustomerInformation {
  private cliente: number;
  private categoriaCliente: CustomerCategory;
  private avalista: boolean;
  private socio: boolean;
  private telefones: TelefonesClientePropostaResponse[];

  constructor() {}

  public getCliente(): number {
    return this.cliente;
  }

  public setCliente(cliente: number): void {
    this.cliente = cliente;
  }

  public getCategoriaCliente(): CustomerCategory {
    return this.categoriaCliente;
  }

  public setCategoriaCliente(categoriaCliente: CustomerCategory): void {
    this.categoriaCliente = categoriaCliente;
  }

  public isAvalista(): boolean {
    return this.avalista;
  }

  public setAvalista(avalista: boolean): void {
    this.avalista = avalista;
  }

  public isSocio(): boolean {
    return this.socio;
  }

  public setSocio(socio: boolean): void {
    this.socio = socio;
  }

  public getTelefones(): TelefonesClientePropostaResponse[] {
    return this.telefones;
  }

  public setTelefones(telefones: TelefonesClientePropostaResponse[]): void {
    this.telefones = telefones;
  }

  setCustomerInformations(customerInformations: CustomerInformation) {
    this.cliente = customerInformations.cliente;
    this.categoriaCliente = customerInformations.categoriaCliente;
    this.avalista = customerInformations.avalista;
    this.socio = customerInformations.socio;
    this.telefones = customerInformations.telefones;
  }

  getAllPhone(customerInformation: CustomerInformation[]): string[] {
    const phones: string[] = [];
    customerInformation.forEach((customer) => {
      customer.telefones.forEach((phone) => {
        phones.push(phone.ddd + phone.telefone);
      });
    });

    return phones;
  }
}
